import React from 'react';
import { CustomComponentsProps } from '@website-editor/customComponents';
import { VideoAddEdit } from './pages/VideoAddEdit';
import { VIDEO_ACTIONS } from './Video.constants';

interface PhotoNavigationsProps extends CustomComponentsProps {}

export const getVideoNavigations = (props: PhotoNavigationsProps) => {
  const photoAdd = (
    <VideoAddEdit
      type={VIDEO_ACTIONS.VIDEO_ADD}
      {...props}
    />
  );
  const photoEdit = (
    <VideoAddEdit
      type={VIDEO_ACTIONS.VIDEO_EDIT}
      {...props}
      isEditMode
    />
  );
  return [photoAdd, photoEdit];
};
